<div class="upper-menu ion-text-center flex-container justify-center">
    <div class="flex-item" style="visibility:hidden">SOS</div>
    <div class="flex-item" style="visibility:hidden"></div>
    <div class="flex-item sos cmn-font-helvetica" (click)="openLink()">SOS</div>
</div>